// @ts-nocheck
import type { ResponseTraitError } from "@/types/Error/Error";
import { useErrorHandler } from "@/shared/composables/useErrorHandler";

export default async function requestResponseTrait(response: Response) {
	if (!response.ok) {
		const err = (await response.json()) as ResponseTraitError;
		const error = new Error();
		error.message = err.message || err.error?.message || err.response?.message || "An unexpected error occurred";
		error.status = err.status;
		error.date = err.date;
		error.error = err.error;

		if (err.status === 403) {
			const { handleError } = useErrorHandler();
			handleError(error);
		}

		throw error;
	}
}
